"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const auth_1 = require("../../auth");
const exceptions_1 = require("../exceptions");
/**
 * Esegue la richiesta solo se il l'utente è loggato
 *
 * @export
 * @class TokenExists
 * @throws Unauthorized
 */
class Auth {
    constructor(data) {
        if (auth_1.Auth.check()) {
            return Promise.resolve(data);
        }
        throw new exceptions_1.Unauthorized();
    }
}
exports.default = Auth;
